<script setup>
import { ref, onBeforeMount, computed } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useIntegrationsStore } from "@/stores/integrations";
import moment from "moment";
// const props = defineProps({
//   dataCollectionsOptions : Array,
// });
const uiStore = useUiStore();
const integrationsStore = useIntegrationsStore();
const emit = defineEmits(["refreshGrid"]);
const company_id = useCompanyStore().companyId;
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);
const name = ref(null);
const encryptedToken = ref(null);
const stores = ref([]);
const integrationType = ref(null);
const description = ref(null);
let isSubmitted = ref(false);
const isDisabled = computed(() =>
  !stores.value.some((store) => store.value === true || store.auto_create === 1)
);

const resetStoreData = () => {
  uiStore.setModalState(false);
  uiStore.setModalData({});
  uiStore.setModalAction(null);
};

const onStoreChange = (index) => {
  if (!stores.value[index].value) {
    stores.value[index].auto_create = 0;
  }
};

const onSubmit = async () => {
  isSubmitted.value = true;
  const data = {
    name: name.value,
    token: integrationType.value == "vensafe" ? encryptedToken.value : null,
    description: integrationType.value == "on_demand" ? description.value : null,
    integration_type: integrationType.value,
    company_id,
    stores: stores.value
      .filter((store) => store.value)
      .map((store) => ({
        id: store.id,
        name: store.name,
        auto_create: store.auto_create ? 1 : 0,
        data_collection_id: store.data_collection
          ? store.data_collection.id
          : null,
      })),
  };
  integrationsStore
    .createIntegration(data)
    .then(() => {
      resetStoreData();
      emit("refreshGrid");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

onBeforeMount(() => {
  if (
    getModalInfo.value &&
    getModalAction.value == "check_stores_after_submit__vansafe_token"
  ) {
    encryptedToken.value = getModalInfo.value.encryptedToken;
    integrationType.value = "vensafe";
    name.value = `Vensafe (${moment(new Date()).format(
      "DD/MM/YYYY - hh:mm A",
    )})`;
    getModalInfo.value.data.map((row) => {
      stores.value.push({
        id: row.id,
        name: row.name,
        auto_create: 0,
        value: false,
      });
    });
  } else if (getModalAction.value == "create_custom_integration") {
    integrationType.value = "on_demand";
  }
});
</script>
<template>
  <DModal v-if="getModalAction === 'create_data_mapping_integration' || getModalAction === 'create_custom_integration' || getModalAction === 'check_stores_after_submit__vansafe_token'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Create Integration </template>

    <template #body>
      <DInput :value="name" @input="name = $event.target.value" label="Name" width="100%" />

      <FloatLabel v-if="integrationType == 'on_demand'" class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="collectionDescription"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="collectionDescription">Description</label>
      </FloatLabel>

      <div>
        <div v-if="integrationType == 'vensafe'">
          <div class="grid gap-10 mb-3">
            <span class="hint-input mb-1"
              ><b>Note:</b> By checking the create store entry checkbox , you'll
              not only fetch data for your store but also automatically create a
              corresponding store entry in your dashboard.</span
            >
          </div>
          <div class="mb-2">
            <span class="text-gray-500">Stores</span>
          </div>

          <div v-for="(store, index) in stores" :key="store.id || index" class="flex mb-2">
            <!-- <div class="w-full"> -->
            <div class="w-7/12 flex mb-2">
              <div class="checkbox-item">
                <input
                  @change="onStoreChange(index)"
                  type="checkbox"
                  :id="'storeName' + index"
                  :value="'storeName' + index"
                  v-model="store.value"
                />
                <label :for="'storeName' + index">{{ store.name }}</label>
              </div>
            </div>
            <div class="w-5/12 flex mb-2">
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  :id="'autoCreate' + index"
                  :value="'autoCreate' + index"
                  v-model="store.auto_create"
                  :disabled="!store.value"
                />
                <label :for="'autoCreate' + index">Create Store Entry</label>
              </div>
            </div>
            <!-- </div> -->
            <!-- <div class="relative mb-3">
                <span v-if="store.data_collection" class="multiselect-title-span">Data Collection</span>
                <VMultiselect v-model="store.data_collection" :options="props.dataCollectionsOptions" :disabled="!props.dataCollectionsOptions.length || !store.value" :multiple="false"
                :loading="!props.dataCollectionsOptions.length" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Data Collection" trackBy="id" label="name"
                />
              </div> -->
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!name || (isDisabled && integrationType == 'vensafe') || (!description && integrationType == 'on_demand') || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Submit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
